import React from "react";
import "../styles/Skills.css";
import kombaiIcon from "../assets/kombai.png";
import firebaseIcon from "../assets/firebasesvg.svg";
import supabaseIcon from "../assets/supabase.png";
import cursorIcon from "../assets/cursor.png";
import cursorDark from "../assets/cursordark.png";

// Devicon / Simple Icons
import { VscVscode } from "react-icons/vsc";
import { RiJavascriptFill, RiCopilotFill, RiNextjsFill } from "react-icons/ri";
import { FaGitAlt } from "react-icons/fa";
import {
  DiCss3,
  DiJava,
  DiPython,
  DiHtml5,
  DiReact,
} from "react-icons/di";

import {
  SiNpm,
  SiTailwindcss,
  SiMysql,
  SiVite,
  SiFramer,
  SiBootstrap,
  SiVercel,
  SiGithub,
  SiNetlify,
} from "react-icons/si";
import { BiLogoTypescript } from "react-icons/bi";

// Lucide icons for category headers
import { Code, Component, Wrench } from "lucide-react";
import { FaG } from "react-icons/fa6";

const Skills = () => {
  const skillCategories = [
    {
      title: "Languages",
      icon: <Code size={24} />,
      skills: [
        { name: "JavaScript", icon: <RiJavascriptFill size={36} color="#F7DF1E" /> },
        { name: "TypeScript", icon: <BiLogoTypescript size={36} color="#3178C6" /> },
        { name: "Java", icon: <DiJava size={36} color="#007396" /> },
        { name: "Python", icon: <DiPython size={36} color="#3776AB" /> },
        { name: "HTML", icon: <DiHtml5 size={36} color="#E34F26" /> },
        { name: "CSS", icon: <DiCss3 size={36} color="#1572B6" /> },
        { name: "SQL", icon: <SiMysql size={36} color="#4479A1" /> },
      ],
    },
    {
      title: "Frameworks & Libraries",
      icon: <Component size={24} />,
      skills: [
        { name: "React", icon: <DiReact size={36} color="#61DAFB" /> },
        { name: "Next.js", icon: <RiNextjsFill size={36} color="#000000" className="icon-nextjs"/> },
        { name: "Tailwind CSS", icon: <SiTailwindcss size={36} color="#1572B6" /> },
        { name: "Framer Motion", icon: <SiFramer size={36} color="#E91E63" /> },
        { name: "Bootstrap", icon: <SiBootstrap size={36} color="#7952B3" /> },
      ],
    },
    {
      title: "Tools & Technologies",
      icon: <Wrench size={24} />,
      skills: [
        { name: "Git", icon: <FaGitAlt size={36} color="#F05032" className="icon-git" /> },
        { name: "GitHub", icon: <SiGithub size={36} color="#181717" className="icon-github" /> },
        { name: "VS Code", icon: <VscVscode size={36} color="#007ACC" className="icon-vscode" /> },
        { name: "npm", icon: <SiNpm size={36} color="#af0000" /> },
        { name: "Vite", icon: <SiVite size={36} color="#6f00af" /> },
        { name: "Netlify", icon: <SiNetlify size={36} color="#00C7B7" className="icon-netlify" /> },
        { name: "Vercel", icon: <SiVercel size={36} color="#000000" className="icon-vercel" />},
        { name: "Supabase", icon: supabaseIcon, size: 36 },
        { name: "Kombai", icon: kombaiIcon, size: 36 },
        { name: "Firebase", icon: firebaseIcon, size: 36 },
        { 
          name: "Cursor", 
          icon: (
            <div style={{ position: 'relative', width: 36, height: 36 }}>
              <img src={cursorIcon} alt="Cursor" width={36} height={36} className="icon-cursor" />
              <img src={cursorDark} alt="Cursor Dark" width={36} height={36} className="icon-cursordark" style={{ position: 'absolute', top: 0, left: 0 }} />
            </div>
          ), 
          size: 36 
        },
        { name: "GitHub Copilot", icon: <RiCopilotFill size={36} color="#3B82F6" /> },

      ],
    },
  ];

  return (
    <section id="skills" className="skills-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Tech I'm familiar with</h2>
          <div className="section-line"></div>
        </div>

        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category">
              <div className="category-header">
                <div className="category-icon">{category.icon}</div>
                <h3 className="category-title">{category.title}</h3>
              </div>

              <div className="skills-icon-grid">
                {category.skills.map((skill, idx) => (
                  <div key={idx} className="skill-icon-item">
                    <div className="skill-icon">
                      {typeof skill.icon === "string" ? (
                        <img
                          src={skill.icon}
                          alt={skill.name}
                          width={skill.size || 36}
                          height={skill.size || 36}
                        />
                      ) : (
                        skill.icon
                      )}
                    </div>
                    <span className="skill-name">{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;